export default __webpack_public_path__ + "static/media/Seed-Money.b00238a5.svg";